import { Spinner } from "react-bootstrap";
import { useAdvisors } from "../../context/useAdvisorsContext";
import { FaWhatsapp } from "react-icons/fa";
import "./NuestrosAsesores.css";

const NuestrosAsesores = () => {
  const { data: advisors, isLoading, error } = useAdvisors();

  if (isLoading) {
    return (
      <div
        className="nuestros-asesores-section d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando asesores...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <div className="nuestros-asesores-section">
        <h2 className="text-danger text-center">
          Error al cargar los asesores
        </h2>
      </div>
    );
  }

  return (
    <div className="nuestros-asesores-section">
      <h1 className="nuestros-asesores-heading">Nuestros Asesores</h1>

      {advisors && advisors.length > 0 ? (
        <div className="advisors-container">
          {advisors.map((advisor) => (
            <AdvisorCard key={advisor.id} advisor={advisor} />
          ))}
        </div>
      ) : (
        <p className="text-center">No hay asesores disponibles</p>
      )}
    </div>
  );
};

const AdvisorCard = ({ advisor }) => {
  // Get achievement badges from tags (filter out null/undefined and get up to 4)
  const achievementBadges =
    advisor.tags && advisor.tags.length > 0
      ? advisor.tags
          .filter((tag) => tag && (tag.name_es || tag.name || tag.name_en))
          .slice(0, 4)
      : [];

  const getTagText = (tag) => {
    if (!tag) return "";
    if (typeof tag === "string") return tag;
    return (
      tag.name_es || tag.name || tag.name_en || tag.label || tag.title || ""
    );
  };

  const handleWhatsAppClick = () => {
    if (advisor.whatsapp) {
      window.open(`https://wa.me/${advisor.whatsapp}`, "_blank");
    }
  };

  return (
    <div className="advisor-card-wrapper">
      <div className="advisor-card-main">
        {/* Photo Card */}
        <div className="advisor-photo-card">
          <img
            src={advisor.photoUrl}
            alt={advisor.name}
            className="advisor-photo"
          />
        </div>

        {/* Bio Card - Single color background */}
        <div className="advisor-bio-card">
          <img
            src="/images/verified-check.png"
            alt="Verificado"
            className="advisor-verified-icon"
          />

          <h2 className="advisor-name">{advisor.name}</h2>
          <p className="advisor-subtitle">Asesora verificada NoManejes</p>

          <p className="advisor-bio-text">{advisor.description_es}</p>
        </div>
      </div>

      {/* Achievement badges section - centered and smaller */}
      {achievementBadges.length > 0 && (
        <div className="advisor-achievements">
          <div className="achievements-grid">
            {achievementBadges.map((badge, idx) => {
              const tagText = getTagText(badge);
              if (!tagText) return null;
              return (
                <div key={idx} className={`achievement-badge badge-${idx % 2}`}>
                  <p className="badge-text">{tagText}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* CTA Button with WhatsApp icon */}
      <button className="advisor-cta-button" onClick={handleWhatsAppClick}>
        <span>Hablar con {advisor.name.split(" ")[0]} ahora</span>
        <FaWhatsapp />
      </button>
    </div>
  );
};

export default NuestrosAsesores;
